<h1 mat-dialog-title>Conferma</h1>
<div mat-dialog-content>
  <form #form="ngForm">
    <mat-form-field>
      <mat-label>Quantità</mat-label>
      <input type="number" name="quantity" min="1" matInput [(ngModel)]="quantity" required>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Prezzo Certificato</mat-label>
      <input type="string" name="prezzoCertificato" [pattern]="doubleFormatRegex" matInput
        [(ngModel)]="prezzoCertificato" required #prezzoCertificatoModel="ngModel">
      <mat-error *ngIf="prezzoCertificatoModel.invalid && (prezzoCertificatoModel.dirty || prezzoCertificatoModel.touched)">
        {{isPrezzoCertificatoValido() ? 'Utilizzare il punto come separatore decimale nell\'importo' : 'Inserire un prezzo maggiore di 0'}}
      </mat-error>
    </mat-form-field>
    <mat-form-field style="width: 185px">
      <mat-label>Inserisci una data</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="isinDate" name="isinDate" required disabled>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker disabled="false"></mat-datepicker>
    </mat-form-field>
    <mat-form-field *ngIf="isPortafoglio == false">
      <mat-label>Scegli il portafoglio</mat-label>
      <mat-select
      (infiniteScroll)="getNextBatch()"
      [complete]="offset === portafoglioService.userPortfolios.length"
      [(ngModel)]="portafoglio"
      name="portafoglio"
      msInfiniteScroll>
        <mat-option *ngFor="let option of options$ | async" [value]="option">{{option.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onYesClick()" [disabled]="form.invalid || !isinDate || quantity <= 0 || !isPrezzoCertificatoValido()" >Conferma</button>
  <button mat-button (click)="onNoClick()">Cancella</button>
</div>
